export default "__VITE_ASSET__GdmDUND0__"